import kanbanBoardImg from "../assets/kanban-board-project.jpg";
import recipesBookImg from "../assets/recipes-book.png";
import weatherAppImg from "../assets/weather-app.png";
import ageCalculatorImg from "../assets/age-calculator.png";
import multistepFormImg from "../assets/multistep-form.png";
import dinnerSchedulerImg from "../assets/dinner-scheduler.png";
import petEcommerceImg from "../assets/pet-ecommerce.png";
import techBookClubImg from "../assets/tech-book-club.jpg";

export const myProjectsList = [
  {
    id: 1,
    title: "projects.projectPetEcommerce.title",
    img_src: petEcommerceImg,
    description: "projects.projectPetEcommerce.desc",
    technologies: ["Next.js", "Tailwind", "Prisma", "PostgreSQL", "Stripe", "NextAuth"],
    main_technology: "next",
    linkDemo: "https://pet-e-commerce-one.vercel.app/",
    linkCode: "https://github.com/justyna13/Pet-E-Commerce"
  },
  {
    id: 2,
    title: "projects.projectDinnerScheduler.title",
    img_src: dinnerSchedulerImg,
    description: "projects.projectDinnerScheduler.desc",
    technologies: ["Next.js", "Tailwind", "SCSS"],
    main_technology: "next",
    linkDemo: "https://dinner-scheduler.vercel.app"
  },
  {
    id: 3,
    title: "projects.projectMultistepForm.title",
    img_src: multistepFormImg,
    description: "projects.projectMultistepForm.desc",
    technologies: ['React', 'SCSS', 'Vitest', 'Storybook'],
    main_technology: "react",
    linkCode: "https://github.com/justyna13/Multi-step-form",
    linkDemo: "https://multistep-form-justyna.netlify.app",
    frontendMentorLink: "https://www.frontendmentor.io/challenges/multistep-form-YVAnSdqQBJ",
    frontendMentorLinkTitle: "Frontend Mentor | Multi-step form app coding challenge"
  },
  {
    id: 4,
    title: "projects.projectTechBookClub.title",
    img_src: techBookClubImg,
    description: "projects.projectTechBookClub.desc",
    technologies: ["HTML", "SCSS", "JavaScript", "Landing page"],
    main_technology: "html",
    linkCode: "https://github.com/justyna13/Tech-book-club-landing-page",
    linkDemo: "https://justyna13.github.io/Tech-book-club-landing-page/",
    frontendMentorLink: "https://www.frontendmentor.io/challenges/tech-book-club-landing-page-fZQidjHU73",
    frontendMentorLinkTitle: "Frontend Mentor | Tech book club landing page"
  },
  {
    id: 5,
    title: "projects.projectAgeCalculator.title",
    img_src: ageCalculatorImg,
    description: "projects.projectAgeCalculator.desc",
    technologies: ['SCSS', 'Vue', 'Vitest'],
    main_technology: "vue",
    linkCode: "https://github.com/justyna13/Age-calculator-app",
    linkDemo: "https://cheerful-piroshki-dcd042.netlify.app/",
    frontendMentorLink: "https://www.frontendmentor.io/challenges/age-calculator-app-dF9DFFpj-Q",
    frontendMentorLinkTitle: "Frontend Mentor | Age calculator app coding challenge"
  },
  {
    id: 6,
    title: "projects.projectKanban.title",
    img_src: kanbanBoardImg,
    description: "projects.projectKanban.desc",
    technologies: ["HTML", "SCSS", "JavaScript", "React"],
    main_technology: "react",
    linkCode: "https://github.com/justyna13/Kanban-Board",
    linkDemo: "https://kanban-board-justyna.netlify.app/",
    legacy: true
  },
  {
    id: 7,
    title: "projects.projectRecipes.title",
    img_src: recipesBookImg,
    description: "projects.projectRecipes.desc",
    technologies: ['HTML', 'CSS', 'React', 'Redux', 'Firebase'],
    main_technology: "react",
    linkCode: "https://github.com/justyna13/RecipesBook",
    linkDemo: "https://recipes-book-justyna.netlify.app/",
    legacy: true
  },
  {
    id: 8,
    title: "projects.projectWeatherApp.title",
    img_src: weatherAppImg,
    description: "projects.projectWeatherApp.desc",
    technologies: ['HTML', 'CSS', 'JavaScript', 'React'],
    main_technology: "html react",
    linkCode: "https://github.com/justyna13/Weather-App",
    linkDemo: "https://happy-yalow-1a6a58.netlify.app/",
    legacy: true
  }
]
